import { openBlock, createElementBlock, Fragment, renderSlot } from "vue";
import { ALIGNMENTS_ENUMS } from "./constants.mjs";
const _sfc_main = {
  __name: "FhDataTableColumn",
  props: {
    align: {
      type: String,
      default: ALIGNMENTS_ENUMS.START,
      validator: (value) => Object.values(ALIGNMENTS_ENUMS).includes(value)
    },
    name: {
      type: String,
      default: ""
    },
    sortable: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        renderSlot(_ctx.$slots, "header"),
        renderSlot(_ctx.$slots, "custom")
      ], 64);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=FhDataTableColumn.mjs.map
